// extracted by mini-css-extract-plugin
export var actions = "_qq-5";
export var assistantBubble = "_qq-3";
export var assistantRow = "_qq-6";
export var bubble = "_qq-0";
export var humanAvatar = "_qq-4";
export var inlineToolCard = "_qq-1";
export var userBubble = "_qq-2";